import { render, staticRenderFns } from "./formscreen.vue?vue&type=template&id=5f5d6c10&scoped=true&"
import script from "./formscreen.vue?vue&type=script&lang=js&"
export * from "./formscreen.vue?vue&type=script&lang=js&"
import style0 from "./formscreen.vue?vue&type=style&index=0&id=5f5d6c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d6c10",
  null
  
)

export default component.exports